import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const getMonitors = () => api.get('/monitors');
export const getMonitor = (id) => api.get(`/monitors/${id}`);
export const createMonitor = (data) => api.post('/monitors', data);
export const updateMonitor = (id, data) => api.put(`/monitors/${id}`, data);
export const deleteMonitor = (id) => api.delete(`/monitors/${id}`);
export const getMonitorRuns = (id, limit = 50) => api.get(`/monitors/${id}/runs?limit=${limit}`);
export const getMonitorAlerts = (id) => api.get(`/monitors/${id}/alerts`);
export const getMonitorAlertStatus = (id) => api.get(`/monitors/${id}/alert-status`);

export const getSubscriptions = () => api.get('/subscriptions');
export const getSubscription = (id) => api.get(`/subscriptions/${id}`);
export const createSubscription = (data) => api.post('/subscriptions', data);
export const createBulkSubscriptions = (subscriptions) => api.post('/subscriptions/bulk', { subscriptions });
export const updateSubscription = (id, data) => api.put(`/subscriptions/${id}`, data);
export const renewSubscription = (id) => api.post(`/subscriptions/${id}/renew`);
export const deleteSubscription = (id) => api.delete(`/subscriptions/${id}`);
export const deleteBulkSubscriptions = (ids) => api.post('/subscriptions/bulk-delete', { ids });
export const updateBulkSubscriptions = (ids, updates) => api.put('/subscriptions/bulk', { ids, updates });

export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

export const changePassword = (data) => api.put('/auth/change-password', data);

export default api;
